export default __webpack_public_path__ + "static/media/register-image.1118dc02.png";